export default function ($scope, ecopontos, map, google, $timeout, $compile) {
    var _ = require('lodash');
    var $ = require('jquery');
    var rd = require('diacritics').remove;
    var MarkerWithLabel = require('markerwithlabel')(google.maps);
    var images = require.context("./images", true, /.*/);
    var icons = require.context("./icons", true, /.*/);
    var templates = require.context("./templates", true, /\.html$/);

    
    var isColocado = function(e) { return e.ec === "Colocado";};
    var isSuspenso = function(e) { return e.ec === "Suspenso";};
    var isIndiferido = function(e) { return e.ec === "Indiferido";};
    var isPendente = function(e) { return e.ec === "Pendente";};
    var isEliminado = function(e) { return (e.ec === "Eliminado" || e.ec === "Retirado");};
    var isEcosound = function(e) { return e.gr != null && e.gr.toLowerCase().includes('ecosound');};
    var isReciclar = function(e) { return e.gr != null && e.gr.toLowerCase().includes('ajudar');};
    var isIlha = function(e) { return rd(e.tipo).toLowerCase().startsWith("ilhas"); };
    var hasWork = function(e) { return rd(e.tipo).toLowerCase().startsWith("ilhas"); };

    var hasCircuito = function(e, searched) {
        if (e.circuitos && Array.isArray(e.circuitos)) {
            for (var i = 0; i < e.circuitos.length; i++) { 
                if (e.circuitos[i] && e.circuitos[i].toLowerCase().indexOf(searched) === 0) {
                    return true;
                }
            }
        }
        
        return false;
    }

    var getInfoWindow = function ($scope, e) {
        var compile = function(tpl, $scope) {
            var c = $compile(templates(tpl))($scope);
            return c[0];
        };

        $scope.ecoponto = e;
        
        if (_.indexOf($scope.access, 'municipios') === -1) {
            return compile("./regular.html", $scope);
        } else if (e.cont.length === 0) {
            if (hasWork(e)) {
                return compile("./advanced-obras-nocont.html", $scope);
            } else {
                return compile("./advanced-nocont.html", $scope);
            }
        } else {
            if (hasWork(e)) {
                return compile("./advanced-obras.html", $scope);
            } else {
                return compile("./advanced.html", $scope);
            }
        }
    };
    
    var getIcon = function(e) { 
        if (isSuspenso(e)) {
            return icons("./suspended.png");
        } else if (isIndiferido(e)) {
            return icons("./indiferido.png");
        } else if (isPendente(e)) {
            return icons("./pending.png");
        } else if (isEliminado(e) && e.pc !== "Sazonal") {
            return icons("./canceled.png");
        } else if (isEcosound(e)) {
            return icons("./ecosound.png");
        } else if (isReciclar(e)) {
            return icons("./ajudar.png");
        } else if (isIlha(e)) {
            return icons("./" + rd(e.con.toLowerCase()) + '_ilhas.png');
        } else {
            try {
                return icons("./" + rd(e.con.toLowerCase()) + '_' 
                                + rd(e.tipo.toLowerCase()).replace(/\W/g,'') + '.png');
            } catch(err) {
                return null;
            }
        }
    };
    
    var getSmallIcon = function(e) { 
        return {
            url: getIcon(e), 
            scaledSize: new google.maps.Size(6, 8), // scaled size
            origin: new google.maps.Point(0,0), // origin
            anchor: new google.maps.Point(0, 0) // anchor
        };
    };
    
    var getImg = function(e) {
        if (isSuspenso(e)) {
            return images("./suspenso.png");
        } else if (isIndiferido(e)) {
            return images("./indiferido.png");
        } else if (isPendente(e)) {
            return images("./pending.png");
        } else if (isEliminado(e)) {
            return images("./eliminado.png");
        } else if (isEcosound(e)) {
            return images("./ecosound.png");
        } else if (isReciclar(e)) {
            return images("./ajudar.PNG");
        } else if (isIlha(e)) {
            return images("./ilhas.jpg");
        } else {
            return images("./" + rd(e.tipo).toLowerCase().replace(/\W+/g, "") + ".jpg");
        }
    };
    
    $scope.ecopontos = _.filter(ecopontos, function(e) { 
        return e.latitude && e.longitude; 
    });
    
    $scope.info = new google.maps.InfoWindow({content: '<div></div>'});

    //setup the markers
    var _parent = 'ecopontos';
    $scope.layers.push({parent: _parent, name: 'Ecopontos', visible: true});
    $scope.layers.push({parent: _parent, name: 'Colocado', visible: true, offseted:true});
    $scope.layers.push({parent: _parent, name: 'Suspenso', visible: false, offseted:true});
    $scope.layers.push({parent: _parent, name: 'Indiferido', visible: false, offseted:true});
    $scope.layers.push({parent: _parent, name: 'Pendente', visible: false, offseted:true});
    $scope.layers.push({parent: _parent, name: 'Eliminado', visible: false, offseted:true});

    

    _.each($scope.ecopontos, function(e){
        e.marker = new google.maps.Marker({
            position: new google.maps.LatLng(e.latitude, e.longitude),
            map: map,
            icon: getSmallIcon(e),
            title: e.cod
        });

        //infowindow on click
        google.maps.event.addListener(e.marker, 'click', function () {
            $timeout(function () {
                map.setCenter(e.marker.getPosition());
                e.img = getImg(e);
                $scope.info.close();
                $scope.info.setContent(getInfoWindow($scope, e));
                $scope.info.open($scope.map, e.marker);
            });
        });
    });
    
    var setMarker = function(e) {
        if (!e.marker) {
            return;
        }
        
        //should show lbled marker
        var _lbl_marker = e.visible 
                && map.getBounds() 
                && map.getBounds().contains(e.marker.getPosition())
                && _.indexOf($scope.access, 'amarsul') !== -1 
                && map.getZoom() >= 16;
        
        
        //should show simple marker
        var _marker = e.visible && !_lbl_marker &&  map.getBounds() && map.getBounds().contains(e.marker.getPosition());
        var _big_marker = map.getZoom() >= 16 && _marker;

        if ((!!e.marker.getMap() !== _marker) || (!!e.big_marker !== _big_marker)) {
            e.marker.setMap(_marker ? $scope.map : null);
            
            //scales marker, if needed
            if (!!e.big_marker !== _big_marker) {
                if (_big_marker) {
                    e.marker.setIcon(getIcon(e));
                } else {
                    e.marker.setIcon(getSmallIcon(e));
                }
                e.big_marker = _big_marker;
            }
        }
        
        if (!e.lbl_marker && _lbl_marker) {           
            e.lbl_marker = new MarkerWithLabel({
                position: new google.maps.LatLng(e.latitude, e.longitude),
                map: map,
                icon: getIcon(e),
                title: e.cod,
                labelContent: e.cod,
                labelAnchor: new google.maps.Point(22, 0),
                labelClass: 'eco-label', // the CSS class for the label 
                labelStyle: {opacity: 0.75}
            });
            
            google.maps.event.addListener(e.lbl_marker, 'click', function () {
                $timeout(function () {
                    map.setCenter(e.marker.getPosition());
                    $scope.info.close();
                    e.img = getImg(e);
                    $scope.info.point = e;
                    $scope.info.setContent(getInfoWindow($scope, e));
                    $scope.info.open($scope.map, e.marker);
                });
            });
        }
        
        if (!!e.lbl_marker && (!!e.lbl_marker.getMap() !== _lbl_marker)) {
            e.lbl_marker.setMap(_lbl_marker ? $scope.map : null);
            
            if (!!e.lbl_marker && !_lbl_marker) {
                e.lbl_marker = false;
            }
        }
        
    }
    
    var refreshMarkers = function() {
        //updates map
        _.each($scope.ecopontos, setMarker);
    };    
    
    map.addListener('bounds_changed' , _.debounce(refreshMarkers,200));

    
    //refresh fcn
    return function() {
        var _mun_activos = _.map(_.filter($scope.municipios, 'visible'),'name');
        var _layers_activas = $scope.layers.filter(l => l.visible && l.parent === _parent).map(l => l.name);
                
        //updates status
        var nvisible = 0;
        _.each($scope.ecopontos, function(e){
            e.visible = _.indexOf(_mun_activos, e.con) !== -1 
                    && _.indexOf(_layers_activas, 'Ecopontos') !== -1 
                    && ((_.indexOf(_layers_activas, 'Colocado') !== -1 && isColocado(e))
                    || (_.indexOf(_layers_activas, 'Suspenso') !== -1 && isSuspenso(e))
                    || (_.indexOf(_layers_activas, 'Indiferido') !== -1 && isIndiferido(e))
                    || (_.indexOf(_layers_activas, 'Pendente') !== -1 && isPendente(e))
                    || (_.indexOf(_layers_activas, 'Eliminado') !== -1 && isEliminado(e)))
                    && e.cod.toLowerCase().indexOf($scope.search.toLowerCase()) === 0 
                    && ($scope.circuito == '' || hasCircuito(e, $scope.circuito.toLowerCase()))
                    && !(_.indexOf($scope.access, 'amarsul') === -1 && e.ec !== "Colocado" && e.pc !== "Sazonal")
                    && e.ec !== "Em Projeto";
            
            nvisible += e.visible;
        });

        refreshMarkers();
    }
}




// WEBPACK FOOTER //
// ./src/ecopontos/setup.js